export default __webpack_public_path__ + "media/zurb/img/icons/favicon/apple-touch-icon-60x60-0b508f82e51b583c9dcd4239ca1b03d1.png";